<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Tipo de Partícipe
          </md-card-header>
          <md-card-content>
            <p align="justify">
              <b>Individual:</b> el titular es el único partícipe del fondo.
            </p>
            <p align="justify">
              <b>Mancomuno conjunto:</b> se necesita la firma del titular Y del mancomuno para cualquier trámite.
            </p>
            <p align="justify">
              <b>Mancomuno indistinto:</b> se necesita la firma del titular O del mancomuno para cualquier trámite.
            </p>                      
            <!--
            <p align="justify">
              <table>
                <tr>
                  <td width="27%" valign="top">Individual:</td>
                  <td>el titular es el único partícipe del fondo.</td>
                </tr>
                <tr>
                  <td width="27%" valign="top">Mancomuno conjunto:</td>
                  <td>se necesita la firma del titular Y del mancomuno para cualquier trámite.</td>
                </tr>
                <tr>
                  <td width="27%" valign="top">Mancomuno indistinto:</td>
                  <td>se necesita la firma del titular O del mancomuno para cualquier trámite.</td>
                </tr>
              </table>  
            </p>-->           
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('titularidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Titularidad *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.titularidad" :disabled="isDisabled" value="Individual">Individual</md-checkbox>
                <md-checkbox v-model="form.titularidad" :disabled="isDisabled" value="Mancomuno conjunto">Mancomuno conjunto</md-checkbox>
                <md-checkbox v-model="form.titularidad" :disabled="isDisabled" value="Mancomuno indistinto">Mancomuno indistinto</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('titularidad')">
                <span class="md-error" v-if="!$v.form.titularidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>          

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>   

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  props:{ isDisabled: Boolean},
  name: 'Item9',
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item9
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        titularidad: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item9
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.form.titularidad == "Individual"){
          index = "10"
        }else{
          index = "11"
        }
        
        this.$emit('setSaveForm', {id:"9", form: this.form, index: index}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
